// extracted by mini-css-extract-plugin
export default {"textInput":"DSAMethodOfRedressOptions-textInput-6e0fc914f7410fde9adf5a1f3d752263"};